export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x8A1D3a4850ed7deeC9003680Cf41b8E75D27e440",
  eulerSwapV1Implementation: "0x4F4FDeE3568aC31C46634fb2Df3FF44A156Be351",
  eulerSwapV1Periphery: "0x31F34124a37f94efd17201A1B88d5008cD444c72",
} as const
